module.exports = __webpack_public_path__ + "img/brand-ad-01.26713b17.png";